import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle((props) => (
    <img className="flex-none mr1 drag-handle" height="15" width="15" src="/img/icons/drag-icon-page.svg" />
));

export default DragHandle;
